import { Grid, InputAdornment, TextField } from '@mui/material';
import RequireIcon from '@mui/icons-material/FiberManualRecord';
import { useStyles } from '../../../styles/NewOrUpdateForm.styles';
import React, { type SetStateAction, useState } from 'react';

/** Text */
type RequiredText<State extends Record<string, any>> = {
    stateKey: string & keyof State;
    label: string;
    draft: [State, React.Dispatch<SetStateAction<State>>];
    validateFn: (text: string) => boolean;
    helperText?: {
        valid: string;
        invalid: string;
    };
    disabled?: boolean;
    type?: 'email' | 'password' | 'text';
    size?: number;
    adornment?: boolean;
};

export const FormRequiredText = <State extends Record<string, any>>({
    stateKey,
    label,
    draft,
    disabled = false,
    type,
    helperText = {
        valid: '',
        invalid: '',
    },
    validateFn,
    size = 9,
    adornment = false,
}: RequiredText<State>) => {
    const classes = useStyles();
    const [draftState, setDraftState] = draft;
    const [isValid, setIsValid] = useState<boolean>(true);

    return (
        <Grid item md={size ?? 6} xs={12} sm={12} className={classes.textInputWrapper}>
            <TextField
                id={`grid-input-${String(stateKey)}`}
                label={label}
                variant='outlined'
                className={classes.textInput}
                value={draftState?.[stateKey] || ''}
                onChange={(e) => {
                    setDraftState({
                        ...draftState,
                        [stateKey]: e.target.value,
                    });
                    setIsValid(validateFn(e.target.value));
                }}
                autoComplete={`new-${type}`}
                type={type || 'text'}
                error={!isValid}
                helperText={isValid ? helperText.valid : helperText.invalid}
                disabled={disabled}
                required={adornment}
                InputProps={
                    adornment
                        ? {
                              endAdornment: (
                                  <InputAdornment position='end'>
                                      <RequireIcon fontSize='inherit' style={{ color: 'red' }} />
                                  </InputAdornment>
                              ),
                          }
                        : undefined
                }
            />
        </Grid>
    );
};
